import type { TFunction } from "i18next";

import type {
  SensorReadingValues,
  SensorTypeTechnicalName,
} from "@core/apis/shared/types/sensors.model";

import type { DiagramSensorConfig } from "./heatingDiagram.types";

/** Sensor types needed for the heating system diagram */
export const HEATING_DIAGRAM_SENSOR_TYPES: SensorTypeTechnicalName[] = [
  "primary_meter",
  "storage_tank_temperature",
  "radiator_system_supply_temp",
  "radiator_system_supply_temp_setpoint",
];

/** Build sensor overlay configs with translated labels */
export const getHeatingDiagramSensorConfigs = (
  t: TFunction
): Record<string, DiagramSensorConfig> => ({
  supply_temperature: {
    type: "primary_meter",
    readingKey: "supplytemp" as keyof SensorReadingValues,
    label: t("primary_supply_temperature"),
    x: 110,
    y: 40,
  },
  return_temperature: {
    type: "primary_meter",
    readingKey: "returntemp" as keyof SensorReadingValues,
    label: t("primary_return_temperature"),
    x: 110,
    y: 230,
  },
  storage_tank_temperature: {
    type: "storage_tank_temperature",
    readingKey: "water_tank_temperature" as keyof SensorReadingValues,
    label: t("storage_tank_temperature"),
    x: 595,
    y: 135,
  },
  radiator_supply_temperature: {
    type: "radiator_system_supply_temp",
    readingKey: "radiator_system_supply_temp" as keyof SensorReadingValues,
    label: t("_common:text_radiator_supply_temperature"),
    x: 610,
    y: 45,
  },
  radiator_supply_temperature_setpoint: {
    type: "radiator_system_supply_temp_setpoint",
    readingKey: "temperature_setpoint" as keyof SensorReadingValues,
    label: t("radiator_supply_temperature_setpoint_desc"),
    x: 720,
    y: 49,
  },
});
